import { ITransformedDineoutCart } from "@dineout-cart-client/interfaces/dineoutCartTypes";
import { getSavingTextInfo } from "./cartHelper";
import { IDineoutCartResponseData } from "@swiggy-private/checkout-core";
import { IWidget } from "@swiggy-private/checkout-core";

const DINEOUT_HEADER_WIDGET = "DINEOUT_CART_SCREEN_HEADER_WIDGET";
const defaultHeaderWidget: IWidget = {
    active: 0,
    id: 0,
    layoutId: 0,
    priority: 0,
    widgetInfo: {
        affordance: false,
        autoScrollTime: 0,
        girforder: false,
        helpIconImage: "",
        mastheadBackgroundImage: "",
        mastheadRewardsBackgroundImage: "",
        popupSavingsBackgroundImage: "",
        tickerTextColor: "positive_Sub",
        savingsImage: "",
        savingsText: "",
        title: "",
        widgetType: DINEOUT_HEADER_WIDGET,
        dineoutMastHeadTextWidget: {
            affordance: false,
            autoScrollTime: -1,
            color: "",
            text: "",
            widgetType: "",
        },
    },
};
export const CartTransformer = (cartResponse: IDineoutCartResponseData): ITransformedDineoutCart => {
    const transformedResponse: ITransformedDineoutCart = {
        ...cartResponse,
        bulkCart: false,
        noRushDeliveryAvailable: false,
        noRushEnabledForStore: false,
        headerWidget: getHeaderWidget(cartResponse.widgets),
        savingsText: getSavingTextInfo(cartResponse),
        superSavingBottomWidget: {
            backgroundImage: "",
            subscriptionData: {},
        },
    };

    return transformedResponse;
};

export const getHeaderWidget = (widgets?: IWidget[]) => {
    const filteredWidgets =
        widgets?.find(ele => ele?.widgetInfo?.widgetType === DINEOUT_HEADER_WIDGET) || defaultHeaderWidget;
    return filteredWidgets;
};
